import React from "react";
import { BusinessGoals } from "../../lib/business-goals.js";
import WStepECommerceBusinessGoal from "./WStepECommerce/WStepECommerceBusinessGoals.jsx";

export default function WStepBusinessGoal(props) {
    // TODO - make WStepECommerceBusinessGoal one
    const modify = {
        goals: BusinessGoals,
    };

    return <WStepECommerceBusinessGoal {...props} {...modify} />;
}
